import { getCurrentlanguage } from "features/apps/global_slice";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "tools/store";
import { words as arabic } from "./ar";
import { words as english } from "./en";

export const LanguageContext = React.createContext({
  translation: english,
  isArabic: false,
  changeTranslation: (val: any) => {},
});

interface LanguageProviderProps {
  children: React.ReactNode;
}

const LanguageProvider = ({ children }: LanguageProviderProps) => {
  const local = useAppSelector(getCurrentlanguage);

  let [translation, setTranslation] = useState(english);

  const changeTranslation = (lang: string) => {
    setTranslation(lang === "en" ? english : arabic);
  };

  useEffect(() => {
    changeTranslation(local);
  }, [local]);

  return (
    <LanguageContext.Provider
      value={{ translation, changeTranslation, isArabic: local === "ar" }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
